/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { Colours, Spacing, Borders } from '../../../styles/variables';
import { FormOutline }               from '../FormOutline';
import { RegularText }               from '../StyledTypography';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledTextInput = RegularText.withComponent('input').extend`
  width: 100%;
  display: block;
  padding: ${Spacing.Tiny};
  border: 1px solid ${Colours.Gallery};
  border-radius: ${Borders.Radius};
  color: ${Colours.Tundora};
  -webkit-appearance: none;
  &:focus:required {
    ${FormOutline(Colours.DodgerBlue)};
  }
  &::placeholder {
	color: ${Colours.SilverChalice};
  }
  &:invalid:not(:focus):not(:placeholder-shown) {
    ${FormOutline(Colours.Carnation)};
  }
  &:required {
    box-shadow: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledTextInput/index.js